import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useGeolocation } from '../../utils/hooks/useGeolocation'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Panel from '../../packages/kiti/components/structure/Panel'
import IconText from '../../packages/kiti/components/presentation/IconText'

const CoordinatesInput = ({ onChange, value, disabled, ...props }) => {
  const { t } = useTranslation(['components', 'common'])
  const { location, loading, error, getLocation } = useGeolocation()
  const handleClick = !!loading || !!disabled ? () => {} : getLocation
  const coord = location ?? (typeof value === 'object' ? value : value ? JSON.parse(value) : null)

  React.useEffect(() => {
    if (location) onChange(JSON.stringify(location))
  }, [location])

  React.useEffect(() => {
    if (coord) onChange(JSON.stringify(value))
  }, [])

  React.useEffect(() => {
    if (error) onChange(undefined)
  }, [error])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#fff3cd',
          color: '#856404',
          border: `1px solid ${COLORS.danger}`,
          borderRadius: '0.5rem',
          padding: '0.75rem',
          fontSize: '0.875rem'
        }}
      >
        <IconText
          justify="center"
          label={t('messages.mobileAccuracy')}
          iconColor="#856404"
          color="#856404"
          iconLeft="BsExclamationTriangle"
          iconSize={1}
        />
      </div>

      <Panel padding={0.6} borderColor={COLORS.light5} onClick={handleClick} style={{ cursor: 'pointer' }}>
        <IconText
          justify="center"
          label={location ? t('updateLocation') : t('saveLocation')}
          color={COLORS.dark4}
          iconLeft="FaMapMarkerAlt"
          iconSize={1}
        />
      </Panel>

      {!error && coord?.latitude != null && coord?.longitude != null && (
        <p style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: COLORS.dark4 }}>
          <Icon name="BsCompass" size={1} />
          <span>
            {t('latitude')}: {coord.latitude}, {t('longitude')}: {coord.longitude}
          </span>
        </p>
      )}

      {error && (
        <p style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: COLORS.red }}>
          <Icon name="BsExclamationTriangle" size={1} color={COLORS.red} />
          <span>
            {t('common:error')}: {error.message?.includes('denied') ? t('permissionDeniedInBrowser') : error.message}
          </span>
        </p>
      )}
    </div>
  )
}

export default CoordinatesInput
